import React, { useEffect } from 'react';

const StaticLandingPage = () => {
  useEffect(() => {
    // Redirect to the static HTML file with cache busting
    window.location.href = `/landing.html?t=${Date.now()}`;
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontSize: '18px',
      }}
    >
      Redirecting to landing page...
    </div>
  );
};

export default StaticLandingPage;
